



























































































import Vue from "vue";
import { callApi } from "@/lib/api";
import InputText from "@/components/atoms/InputText.vue";

export default Vue.extend({
  components: { InputText },
  props: {
    novelId: String, //小説ID
    items: Array as object, //世界観フォルダ
    worldViewsCount: Number, //フォルダに含まれる世界観の数
    isInsert: Boolean, //状態管理用。世界観にフォルダを設定する状態かどうかを管理
    selectedWorldView: Object, //フォルダを設定しようとしている世界観
    selectedFolderId: String, //現在表示しているフォルダID
  },
  data() {
    return {
      folders: this.items || [],
      wholeWorldViewCount: null,
      isEditMode: false,
      pickedDestinationInsertFolder: null,
      toastNoName: null,
      deletedFolderIds: null,
    };
  },
  watch: {
    items() {
      this.folders = this.items;
    },
    worldViewsCount() {
      this.wholeWorldViewCount = this.worldViewsCount;
    },
  },
  async created() {
    this.wholeWorldViewCount = this.worldViewsCount;
  },
  methods: {
    selectFolder(worldViewFolderId) {
      this.$emit("selectedFolder", worldViewFolderId);
    },
    async completeSetFolder() {
      const currentWorldViewFolderId = this.selectedFolderId;

      //移動前のフォルダから世界観を抜いて、移動先に世界観を追加する
      this.folders.forEach((el) => {
        if (el.worldViewFolderId === currentWorldViewFolderId) {
          el.worldViewKeys.splice(el.worldViewKeys.indexOf(this.selectedWorldView.worldViewId), 1);
        }
        if (el.worldViewFolderId === this.pickedDestinationInsertFolder) {
          el.worldViewKeys.push(this.selectedWorldView.worldViewId);
        }
      });

      await this.updateWorldViewFolder(this.folders);
      this.$emit("clickCompleteSetFolder");
    },
    clickCancelInsertFolder() {
      this.$emit("clickCancelInsertFolder");
    },
    async createWorldViewFolder() {
      const { novelId } = this;
      const query = `
      mutation CreateWorldViewFolder ($input: CreateWorldViewFolderInput!){
        createWorldViewFolder (input: $input) {
          worldViewFolderId
          name
        }
      }
      `;
      const { createWorldViewFolder } = await callApi(query, {
        input: {
          novelId,
          name: "新しいフォルダ",
        },
      });
      const folder = {
        worldViewFolderId: createWorldViewFolder.worldViewFolderId,
        name: createWorldViewFolder.name,
        worldViewKeys: [],
      };
      this.folders.push(folder);
    },
    deleteWorldViewFolder(key) {
      if (!this.deletedFolderIds) {
        this.deletedFolderIds = [];
      }
      const result = this.folders.filter((folder) => {
        return folder.worldViewFolderId !== key;
      });
      this.folders = result;
      this.deletedFolderIds.push(key);
    },
    moveWorldViewFolder(key, direction) {
      let sourceIndex = this.folders.findIndex((folder) => {
        return folder.worldViewFolderId === key;
      });
      const targetIndex = direction === "up" ? sourceIndex - 1 : sourceIndex + 1;
      if (targetIndex >= 0 || this.folders.length > targetIndex) {
        let temp = this.folders[sourceIndex];
        Vue.set(this.folders, sourceIndex, this.folders[targetIndex]);
        Vue.set(this.folders, targetIndex, temp);
      }
    },
    async switchEditMode() {
      //編集終了を押した場合、かつ変更していた場合
      if (this.isEditMode) {
        //フォルダ名が空欄があったら更新しないでエラー出す
        let isExistNoNameFolder = false;
        this.folders.forEach((element) => {
          if (!element.name) {
            isExistNoNameFolder = true;
          }
        });
        if (isExistNoNameFolder) {
          this.toastNoName = true;
          setTimeout(() => (this.toastNoName = null), 2000);
          return;
        }
        await this.updateWorldViewFolder(this.folders);
      }
      this.deletedFolderIds = null;
      this.isEditMode = !this.isEditMode;
    },
    async updateWorldViewFolder(folders) {
      const { novelId } = this;
      const query = `
          mutation UpdateWorldViewFolders ($input: UpdateWorldViewFolderInput!){
            updateWorldViewFolder (input: $input) {
              novelId
              items {
                worldViewFolderId
                name
                worldViewKeys
              }
            }
          }
        `;
      //変なデータが有ったらこっそり修正する
      folders.forEach((element) => {
        element.worldViewKeys = element.worldViewKeys
          .filter((key) => key != null)
          .filter((el, index, selfArray) => {
            //重複Keyは排除
            return selfArray.indexOf(el) === index;
          });
      });
      const result = await callApi(query, {
        input: {
          novelId,
          items: folders,
        },
      });
      return result;
    },
  },
});
